import { memo } from "react";
import { useTranslate } from "helpers";
import { TableSearch } from "ui/components/Table/TableSearch";
import { initialDataWithPagination } from "services/api/consts";
import {
  FLEET_VEHICLE_DAMAGE_PIN_CHILD_COLUMNS,
  FLEET_VEHICLE_DAMAGE_SEARCH_COLUMNS,
} from "./consts";
import DamagePinRowChild from "./components/DamagePinRowChild";
import { VehicleDamageSearchResultsProps } from "./types";

const VehicleDamageSearchResults: React.FC<
  VehicleDamageSearchResultsProps
> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onDeleteClick,
  } = props;

  const { t } = useTranslate();

  return (
    <>
      <TableSearch
        columns={FLEET_VEHICLE_DAMAGE_SEARCH_COLUMNS(t, onDeleteClick)}
        columnsChild={FLEET_VEHICLE_DAMAGE_PIN_CHILD_COLUMNS()}
        CustomTableRowChild={DamagePinRowChild}
        childTableTitle="Oznake štete"
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};

export default memo(VehicleDamageSearchResults);
